/* eslint-disable camelcase */
/*
 * AnlieferdatumInput3.tsx - Anlieferfenster mit MUI 5 Erfassen.
 *
 * Created by Dr. Maximillian Dornseif 2023-11-05 in huWaWi3 33.4.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { dateTimeify, dateTimeifyTyped } from 'any-to-luxon';
import { DateTime } from 'luxon';
import React from 'react';
import { Control, Controller, useController, useWatch } from 'react-hook-form';
import { SliderElement } from 'react-hook-form-mui';

interface IAnlieferdatumInput3Props {
  control: Control<any, object>;
  zeitfensterMin?: number;
  zeitfensterMax?: number;
  zeitfensterDefault?: number;
}

export function AnlieferdatumInput3({ control, ...props }: IAnlieferdatumInput3Props) {
  const {
    field: { onBlur: zeitfensterOnBlur },
  } = useController({
    name: 'zeitfenster',
    control,
  });
  const von = useWatch({
    control,
    name: 'anlieferdatum_von',
  });
  const zeitfenster = useWatch({
    control,
    name: 'zeitfenster',
  });
  const anlieferdatum_bis = dateTimeifyTyped(von)?.plus({ days: zeitfenster });

  return (
    <>
      <Box mb={2}>
        <Stack direction="row" spacing={2} justifyContent="space-between">
          <Controller
            name="anlieferdatum_von"
            control={control}
            render={({
              field: { onChange, onBlur, value, name, ref },
              fieldState: { invalid, error },
              formState,
            }) => {
              return (
                <DatePicker
                  label="Anlieferdatum ab"
                  value={dateTimeify(value)}
                  minDate={DateTime.now()}
                  format="yyyy-MM-dd"
                  onChange={(x) => {
                    onChange(x);
                    onBlur(x);
                  }} // send value to hook form
                  disablePast
                  displayWeekNumber
                  slotProps={{ textField: { variant: 'standard' } }}
                />
              );
            }}
          />
          {/* Dient nur Anzeigezwecken, ist Disabled und Read Only. */}
          <DatePicker
            label="Anlieferdatum bis"
            readOnly={true}
            disabled={true}
            value={anlieferdatum_bis}
            format="yyyy-MM-dd"
            disablePast
            displayWeekNumber
            slotProps={{ textField: { variant: 'standard' } }}
          />
        </Stack>
      </Box>
      <Box mb={2}>
        <Typography gutterBottom variant="body2">
          Zeitfenster {zeitfenster} Tage
        </Typography>
        <SliderElement
          onBlur={zeitfensterOnBlur} // SliderElement ist buggy
          name="zeitfenster"
          control={control}
          valueLabelDisplay="auto"
          step={1}
          defaultValue={props.zeitfensterDefault || 28}
          min={props.zeitfensterMin || 7}
          max={props.zeitfensterMax || 180}
        />
      </Box>
    </>
  );
}
